import { Pack } from '../reducer/packVertices';
export const getPackId = (pack: Pack) => `${pack.parentVertexId}:${pack.type}`;
export const isPack = (id: string, allPacks: Pack[]) =>
  allPacks.find((p) => getPackId(p) === id) !== undefined;
